import React from 'react';

interface LabelProps {
    text: string;
    textColor?: string;
    backgroundColor?: string;
    className?: string;
    marginBottom?: number;
    imgSrc?: string;
}

const LabelTag = ({
                      text,
                      textColor = 'white',
                      backgroundColor = '#000000',
                      marginBottom = 0,
                      imgSrc,
                  }: LabelProps) => {
    return (
        <span
            style={{
                color: textColor,
                backgroundColor: backgroundColor,
                fontSize: '9pt',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '3px',
                paddingBottom: '3px',
                borderRadius: '3px',
                display: imgSrc ? 'inline-flex' : 'inline-block',
                alignItems: imgSrc ? 'center' : undefined,
                whiteSpace: 'nowrap',
                marginRight: '3px',
                marginBottom: `${marginBottom}px`,
                fontFamily: 'Source Sans Pro',
            }}>
            {imgSrc && <img src={imgSrc} style={{ width: '12px', height: '12px', marginRight: '6px' }} alt="" />}{text}
        </span>
    );
};

export default LabelTag;
